// SHELL-USER-KEY-1 (tickets/bellforge.md, 2026-08-15): on a warm-start boot
// the `currentUser*` identity keys come from the CACHED snapshot, while the
// full `root.user` record is stamped pre-create only when the LIVE getMe
// succeeds (bootShell.js `context.state.user = _me`). When getMe fails
// ambiguously (`_getMeUnresolved` — transport error, 5xx — routine on a
// loaded dev box), the boot correctly proceeds without it, but nothing
// retried the stamp, so `root.user` stayed null for the whole session —
// measured live: `root.user`/`root.me` empty while `currentUserId`/
// `currentUserEmail` landed, silently emptying every consumer that reads
// the record (globalRole gates, display names).
//
// One-shot, non-blocking heal, called from loadPrivateData on every boot
// pass: when the record is missing but the session is real, re-fetch getMe
// and stamp it reactively. The latch is a plain property on purpose (not
// state — a failed heal must not re-render anything; the next full boot
// retries naturally). Returns the in-flight promise for tests; callers
// fire-and-forget.
export const healUserRecord = (root, sdk) => {
  if (!root || !sdk || typeof sdk.getMe !== 'function') return null
  if (root.user || !root.currentUserId || root._userRecordHealTried) return null
  root._userRecordHealTried = true
  return (async () => {
    try {
      const meRes = await sdk.getMe()
      const me = (meRes && (meRes.user || (meRes.data && meRes.data.user))) || meRes
      if (me && (me._id || me.id) && !root.user) {
        root.update({ user: me })
        return true
      }
    } catch (_) {
      /* ambiguous again — leave null; canonical identity keys still work */
    }
    return false
  })()
}
